<template>
	<div>
		<el-table
			:data="tableData"
			border
			:max-height="tableHeight || maxHeight"
			v-loading="loading"
			ref="table"
			highlight-current-row
			:row-key="rowKey"
		>
			<slot></slot>
		</el-table>
		<div style="margin: 10px;overflow: hidden">
			<div style="float: right;">
				<el-pagination
					:current-page="pageParams.page"
					:page-size="pageParams.size"
					:total="total"
					@size-change="handleSizeChange"
					@current-change="handleCurrentChange"
					layout="prev, pager, next"
				>
				</el-pagination>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	props:{
		rowKey: {
			type: String || Function,
			default: "",
		},
		list:{
			type: Array,
			default: () => []
		},
		count:{
			type:Number,
			default:10
		},
		autoHeight: {
			type: Boolean,
			default: false
		}
	},
	data(){
		return {
			data:[],
			tableData:[],
			pageParams:{
				count:this.count,
				page:1
			},
			total:0,
			loading:false,
			maxHeight: window.innerHeight > document.body.clientHeight ? 690 : 'auto',
            tableHeight:''
		}
	},
	watch: {
		list: {
			handler: function(newVal,oldVal){
				this.data = newVal;
				this.total = newVal.length;
				this.tableData =  this.currentChangePage(this.pageParams.count,this.pageParams.page)
			},
			immediate:true
		}
	},
	mounted () {
		if (this.autoHeight) {
			this.$nextTick(() => {
				this.setMaxHeight()
			})
		}
	},
	methods:{
		// 计算并设置最大高度
		setMaxHeight() {
			let height =
				document.body.clientHeight -
				this.$refs.eTable.getBoundingClientRect().top -
				90;
			if (height >= 300) {
				this.tableHeight = height;
			}
		},
		/** 切换每页显示条数 */
		handleSizeChange(val) {
			this.pageParams.page = 1;
			this.pageParams.count = val;
			this.tableData = this.currentChangePage(val, this.pageParams.page);
			this.total = this.data.length;
		},
		/** 切换分页 */
		handleCurrentChange(val) {
			this.pageParams.page = val;
			this.tableData = this.currentChangePage(this.pageParams.count, val);
			this.total = this.data.length;
		},
		// 分页方法
		currentChangePage(size, current) {
			const tablePush = [];
			let array = this.jsonCopy(this.data);
			array.forEach((item, index) => {
				if (size * (current - 1) <= index && index <= size * current - 1) {
				tablePush.push(item);
				}
			});
			return tablePush;
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/components/common/eTable.vue